"use strict";import{Button as t}from"./src/Button.js";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";e("sp-button",t);
//# sourceMappingURL=sp-button.js.map
